import * as React from "react";
const SvgFiRrExchangeCryptocurrency = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-exchange-cryptocurrency_svg__a)">
      <path
        fill="#062147"
        d="M24 8.5C24 3.813 20.187 0 15.5 0S7 3.813 7 8.5s3.813 8.5 8.5 8.5S24 13.187 24 8.5M15.5 15A6.51 6.51 0 0 1 9 8.5C9 4.916 11.916 2 15.5 2S22 4.916 22 8.5 19.084 15 15.5 15m-.789 4.19a1 1 0 0 1 .223 1.397A8.28 8.28 0 0 1 8.25 24C3.701 24 0 20.299 0 15.75a8.28 8.28 0 0 1 3.413-6.684.998.998 0 1 1 1.173 1.619A6.27 6.27 0 0 0 2 15.749a6.257 6.257 0 0 0 6.25 6.25 6.28 6.28 0 0 0 5.065-2.586 1 1 0 0 1 1.396-.223zm4.094-12.44A2.55 2.55 0 0 0 16.3 4.205V3.73a.8.8 0 1 0-1.6 0V4.2h-.652c-.717 0-1.3.583-1.3 1.3v6c0 .717.583 1.3 1.3 1.3h.652v.45a.8.8 0 1 0 1.6 0v-.45h.143a2.553 2.553 0 0 0 2.55-2.55c0-.727-.305-1.383-.795-1.85a2.54 2.54 0 0 0 .608-1.65m-4.458-.95h1.908a.95.95 0 0 1 0 1.9h-1.908zm2.094 5.4h-2.094V9.3h2.094a.95.95 0 0 1 0 1.9m7.01 10.125-2.225 2.36a1 1 0 0 1-1.414.043 1 1 0 0 1-.042-1.414L21.008 21h-3.01a1 1 0 0 1 0-2h3.01l-1.239-1.314a1.001 1.001 0 0 1 1.456-1.372l2.244 2.382c.71.709.71 1.898-.02 2.629zM.527 5.304c-.709-.71-.709-1.9.021-2.63L2.772.315a1 1 0 1 1 1.456 1.372L2.99 3H6a1 1 0 0 1 0 2H2.99l1.238 1.314a1.001 1.001 0 0 1-1.456 1.372z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-exchange-cryptocurrency_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrExchangeCryptocurrency;
